export const objectRemoveEmptyValues = (obj: Record<string, any>) =>
  objectFromEntries(Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined));

const objectFromEntries = (iterable: Array<[string, any]>) =>
  [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
